import React from 'react';
import { Image, Segment } from 'semantic-ui-react';
import { getCDNpath } from '../../app/common/util';

const noCard = getCDNpath('/static/images/no-card-icon.png');

const NoCards = () => (
  <Segment className="no-content-segment" textAlign="center">
    <Image alt="No stored cards found!" centered src={noCard} />
    <p>You don't have any stored cards yet.</p>
  </Segment>
);

export default NoCards;